import { View } from '../../../../components/discover/aivy-pdf-reports/compiler'
import AtAGlance from '../../../../components/discover/aivy-pdf-reports/components/matchingProfile/AtAGlance'
import MatchingDimensionCard from '../../../../components/discover/aivy-pdf-reports/components/matchingProfile/MatchingDimensionCard'
import OurReview from '../../../../components/discover/aivy-pdf-reports/components/matchingProfile/OurReview'
import { useTranslationContext } from '../../../../components/discover/aivy-pdf-reports/context/general-translations'

export default function SkillsDetailsMessage({
  skillsCategory,
  overall_insights,
  score_visible,
  our_review_title,
  skills_dimensions,
  language,
  insights_labels
}) {
  const { tGeneral } = useTranslationContext()
  return (
    <div>
      <View>
        <AtAGlance
          title={skillsCategory.name[language]}
          description={tGeneral('skills_description')}
          score={overall_insights.insights.skills.group_match}
          score_visible={score_visible}
        />
      </View>
      <View style={{ marginTop: 16 }}>
        <OurReview
          title={our_review_title}
          description={`${overall_insights.insights.skills.category_fit} ${overall_insights.insights.skills.evaluation_level}`}
          score={overall_insights.insights.skills.group_match}
        />
        {skills_dimensions.map(({ dimension, match, text_modules }, index) => {
          return (
            <View key={index} style={{ marginTop: 16 }}>
              <MatchingDimensionCard
                {...{
                  dimension,
                  match,
                  text_modules,
                  insights_labels,
                  language
                }}
              />
            </View>
          )
        })}
      </View>
    </div>
  )
}
